<template>
<!-- 余额提现 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :model="filters" class="findform">
        <el-form-item label="姓名：" style="display:flex;width:25%">
          <el-input v-model="filters.channelName" placeholder="请输入姓名 (20字以内)" maxlength="20" style="width:90%"/>
        </el-form-item>
        <el-form-item label="手机号：" style="display:flex;width:25%">
          <el-input v-model="filters.partnerPhone" placeholder="请输入手机号" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" maxlength="11" style="width:90%"/>
        </el-form-item>
        <el-form-item label="状态：" style="display:flex;width:25%;" class="select">
          <el-select v-model="filters.stateWithdrawal" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in genderArr" :key="index" :label="item.Name" :value="item.Id"/>
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <el-col :span="18">
        <p class="model_top_title">余额提现</p>
      </el-col>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="用户名" align="center">
          <template scope="scope">
            <span :title="scope.row.userName">{{scope.row.userName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template scope="scope">{{scope.row.userPhone}}</template>
        </el-table-column>
        <el-table-column label="账户类型" align="center">
          <template scope="scope">{{scope.row.accountTypeName}}</template>
        </el-table-column>
        <el-table-column label="未结算" align="center">
          <template scope="scope">{{scope.row.unSettlement}}</template>
        </el-table-column>
        <el-table-column label="可提现" align="center">
          <template scope="scope">{{scope.row.notWithdraw}}</template>
        </el-table-column>
        <el-table-column label="累计提现总额" align="center">
          <template scope="scope">{{scope.row.totalWithdraw}}</template>
        </el-table-column>
        <el-table-column label="申请提现金额" align="center">
          <template scope="scope">{{scope.row.amount}}</template>
        </el-table-column>
        <el-table-column label="到账账户" align="center">
          <template scope="scope">{{scope.row.wechatAccount}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">{{scope.row.stateName}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="endToExamine(scope.row)"
              :style="{color: scope.row.state == 2 ? '#ccc' : '#6786b4'}">
              <i class="el-icon-s-check"/> 审核
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 提现订单-弹框 -->
  <el-dialog title="提现订单" :visible.sync="isToExamine" :center="true" width="50%">
    <div style="margin-bottom: 20px;">
      <span>用户ID：<b>{{orderStatistics.userId}}</b>,</span>
      <span> 手机号：<b>{{orderStatistics.userPhone}}</b>,</span>
      <span> 到账账户：<b>{{orderStatistics.wechatAccount}}</b>,</span>
      <span> 账户余额：<b>{{orderStatistics.balance}}</b></span>
    </div>
    <el-table :data="activeOrderList" style="margin: 0px">
      <el-table-column property="orderTypeName" label="订单属性" align="center"/>
      <el-table-column property="orderPrice" label="订单金额" align="center"/>
      <el-table-column property="orderNo" label="订单号" align="center"/>
      <el-table-column property="placeOrderTime" label="下单时间" align="center"/>
      <el-table-column property="orderStateName" label="订单状态" align="center"/>
      <el-table-column property="amount" label="提现金额" align="center"/>
      <el-table-column property="commissionPrice" label="合伙人返佣" align="center"/>
      <el-table-column property="reviewStateName" label="提现状态" align="center"/>
    </el-table>
    <!-- 弹框按钮 -->
    <div class="btnDiv">
      <span>申请提现金额: <b>{{orderStatistics.amount}}元</b></span>
      <button type="button" v-if="stateType == 1"
        @click="editSubmit(2)" class="el-button search_btn normal_btn">通过</button>
      <button type="button" v-if="stateType == 1"
        @click="editSubmit(3)" class="el-button cancle">拒绝</button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import { getWithdraw, getWithdrawDetail, putWithdraw } from "../../api/attractInvestment";
export default {
  name: 'withdrawalOfBalance',
  data() {
    return {
      show3: true, // 查询区域默认展开
      rooid: "", // 提现记录id
      stateType: "", // 状态id
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      filters: {
        channelName: "", // 姓名
        partnerPhone: "", // 手机号
        stateWithdrawal: 0, // 状态
      },
      genderArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "未审核"
        },
        {
          Id: 2,
          Name: "已通过"
        },
        {
          Id: 3,
          Name: "未通过"
        }
      ],
      isToExamine: false, // 弹框
      orderStatistics: [], // 提现统计统计
      activeOrderList: [], // 提现列表
    }
  },
  methods: {
    //查询列表
    getInit() {
      let addParams = {
        Name: this.filters.channelName, // 姓名
        Phone: this.filters.partnerPhone, // 手机号
        State: this.filters.stateWithdrawal, // 状态
        pageIndex: this.pageIndex,// 当前页码
        pageSize: this.pageSize // 每页显示条数
      };
      getWithdraw(addParams).then(data => {
        this.dataList = data.resultObj.resultObj;
        this.totalRowsCount = data.resultObj.rowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 审核
    endToExamine(row) {
      if (row.state == 2) { return; }
      this.rooid = row.id;
      this.stateType = row.state; // 状态Id
      this.isToExamine = true;
      // 查询用户提现记录详情
      var obj = {
        withdrawRecordId: this.rooid, // 提现记录主键id【必填】
      };
      getWithdrawDetail(obj).then((data) => {
        if(data) {
          if (data.resultCode == 1) {
            this.orderStatistics = data.resultObj; // 提现记录
            this.activeOrderList = data.resultObj.withdrawOrders; // 提现记录列表
          } else {
            this.orderStatistics = [];
            this.activeOrderList = [];
          }
        } else {
          this.orderStatistics = [];
          this.activeOrderList = [];
        }
      });
    },
    // 通过 & 拒绝
    editSubmit(stateVal) {
      this.$swal({
        type: "warning",
        text: stateVal == 2 ?"此操作不可逆，请确定是否通过？" : "请再次确认是否拒绝？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var loginParams = {
            id: this.rooid, // 提现记录id
            reviewer: localStorage.Id, // 当前操作人id
            state: stateVal,
            remark: '暂无',
            userPhone: this.orderStatistics.userPhone // 用户电话
          };
          putWithdraw(loginParams).then(data => {
            if(data.resultCode == 1) {
              this.$swal({
                type: "success",
                text: data.resultMsg,
              });
              this.isToExamine = false;
              this.getInit();
            } else {
              this.$swal({
                type: "warning",
                text: data.resultMsg,
              });
            }
          })
        }
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        channelName: "", // 姓名
        partnerPhone: "", // 手机号
        stateWithdrawal: 0, // 状态
      }
      // this.pageIndex = 1;
      // this.getInit();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
  },
  created() {
    this.getInit(); // 查询列表
  }
}
</script>
<style scoped>
/* 审核操作按钮区域 */
.btnDiv {
  width: 98%;
  margin-top: 20px;
  text-align: right;
}
.btnDiv span {
  font-size: 15px;
  margin-right: 10px;
}
.btnDiv span b {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// withdrawalOfBalance.vue?21737f28